import React, { useContext, useMemo } from 'react';
import { connect } from 'react-redux';
import { Modal, Button } from 'antd';

import { CurrentApplicationContext } from '../../../ApplicationOverview';
import { inviteAllApplicants } from '../../../store/actions';
import { getTranslatedString } from 'helpers/i18n';
import { useQueryClient } from '@tanstack/react-query';

const InviteAllText = getTranslatedString(
  'landlordPortal.applicationManagement.applicationOverview.InviteAll'
);

const InviteApplicantsButton = ({ inviteAllApplicants }) => {
  const application = useContext(CurrentApplicationContext);
  const queryClient = useQueryClient();

  const applicantsWithoutContactMethod = useMemo(() => {
    return application.cotenants.filter((a) => !a.contact_methods.length);
  }, [application]);

  const namesWithoutContactMethod = useMemo(() => {
    return applicantsWithoutContactMethod.map((a) => a.full_name).join(', ');
  }, [applicantsWithoutContactMethod]);

  const modalTitle = useMemo(() => {
    const prefix = `landlordPortal.applicationManagement.applicationOverview.InviteAll.modal.title`;
    return getTranslatedString(
      applicantsWithoutContactMethod.length ? `${prefix}.missingContact` : `${prefix}.haveContact`
    );
  }, [applicantsWithoutContactMethod]);

  const modalMsg = useMemo(() => {
    const prefix = `landlordPortal.applicationManagement.applicationOverview.InviteAll.modal.text`;
    return getTranslatedString(
      applicantsWithoutContactMethod.length ? `${prefix}.missingContact` : `${prefix}.haveContact`,
      { applicantNames: namesWithoutContactMethod }
    );
  }, [applicantsWithoutContactMethod]);

  const handleInvite = () => {
    const confirmationModal = Modal.confirm({
      title: modalTitle,
      content: modalMsg,
      onOk: async () => {
        confirmationModal.update({ okButtonProps: { loading: true } });

        // TODO - render error message at top of Overview tab if failed to send invitations
        await inviteAllApplicants(application.id);
        queryClient.invalidateQueries({ queryKey: ['applications'] });
        confirmationModal.destroy();
      },
      okText: getTranslatedString('send'),
    });
  };

  return (
    <Button key="invite_all" type="primary" onClick={handleInvite}>
      {InviteAllText}
    </Button>
  );
};

export default connect(null, { inviteAllApplicants })(InviteApplicantsButton);
